import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

const setVendorizedProductName = () => {
  const vendorizedProductName = i18n.t(process.env.REACT_APP_PRODUCT_NAME);
  i18n.options.interpolation.defaultVariables = { vendorizedProductName };
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    debug: false,
    supportedLngs: ['en','ja'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'vendor',
    ns: ['vendor'],
    react: {
      useSuspense: false
    }
  });

//i18n.changeLanguage('en'); // This needs to be removed when Japanese is Enabled.

// Dynamically set the vendorizedProductName after initialization
i18n.on('initialized', setVendorizedProductName);
i18n.on('languageChanged', setVendorizedProductName);

export function getLocalizedValue(key, namespace, options = {}) {
  if (i18n.language && namespace && !i18n.hasLoadedNamespace(namespace)) {
    try {
      i18n.addResourceBundle(i18n.language, namespace, require(`./locales/${i18n.language}/${namespace}.json`),false, true);
    }
    catch (e) {
      console.log(e);
    }
  }
  return i18n.t(key, { ns: namespace, ...options });
}

export default i18n;